const {
  commercialPropertyDetailRentURL,
  commercialPropertyDetailSaleURL,
  newHomeDetailURL,
  propertyDetailSaleURL,
  propertyDetailRentURL,
} = require("./urls")

const getPropertyURL = ({
  department,
  slug,
  strapi_id,
  strapiID,
  objectID,
  status,
  search_type,
  searchType,
}) => {
  let propertyURL = propertyDetailSaleURL
  if (department === "residential") {
    if (search_type === "lettings" || searchType === "lettings") {
      propertyURL = propertyDetailRentURL
    } else {
      propertyURL = propertyDetailSaleURL
    }

    const propertyId = strapi_id || objectID || strapiID
    propertyURL += `${slug}/${propertyId}/`
  } else if (department === "commercial") {
    if (search_type === "lettings" || searchType === "lettings") {
      propertyURL = commercialPropertyDetailRentURL
    } else {
      propertyURL = commercialPropertyDetailSaleURL
    }

    const propertyId = strapi_id || objectID || strapiID
    propertyURL += `${slug}/${propertyId}/`
  } else if (department === "new-homes" || department === "newhomes") {
    propertyURL = newHomeDetailURL
    propertyURL += `${slug}/`
  }

  return propertyURL
}

module.exports = { getPropertyURL }
